import { Image, Page, View } from "@react-pdf/renderer";
import React from "react";
import { PDFPageHeader } from "../page-header";
import { PDFPageBody } from "../page-body";
import { PDFPageFooter } from "../page-footer";
import {
  PDFBackgroundDarkS3,
  PDFBackgroundLightS3,
  PDFStyleConfigs,
} from "../../configs";
import { AnalysisDTO } from "@models/platform-analysis/entities/analysis";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";

export const PDFPageContainer = ({
  children,
  isFirstPage = false,
  totalPage,
  pageIndex,
  analysis,
  isAppendix,
}: {
  children?: React.ReactNode;
  isFirstPage?: boolean;
  totalPage?: number;
  pageIndex?: number;
  analysis?: AnalysisDTO;
  isAppendix?: boolean;
}) => {
  const { pageStyle } = useAnalysisPDFStyles();

  return (
    <Page style={{ ...pageStyle.container }}>
      <View style={{ ...pageStyle.layout }}>
        <PDFPageHeader
          isFirstPage={isFirstPage}
          pageIndex={pageIndex}
          isReview={analysis?.isReview}
          adviserFirmLogo={analysis?.summary?.firmLogo ?? ""}
          isAppendix={isAppendix}
        />
        <View style={{ gap: PDFStyleConfigs.GapMedium }}>
          <PDFPageBody
            isFirstPage={isFirstPage}
            pageIndex={pageIndex}
            isReview={analysis?.isReview}
          >
            {children}
          </PDFPageBody>
          <PDFPageFooter
            pageIndex={pageIndex}
            totalPage={totalPage}
            analysis={analysis}
            isFirstPage={isFirstPage}
            isReview={analysis?.isReview}
          />
        </View>
      </View>

      <Image
        src={isFirstPage ? PDFBackgroundDarkS3 : PDFBackgroundLightS3}
        style={{
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -1,
          position: "absolute",
        }}
      />
    </Page>
  );
};
